import { gql } from '@apollo/client'

const GET_REQUEST_COUNT = gql`
  query getAllMyRequests($idWatcher: UUID) {
    requests(filter: { idWatcher: { equalTo: $idWatcher } }) {
      totalCount
    }
  }
`
export default GET_REQUEST_COUNT
